import React, { useEffect, useState, useContext, lazy, Suspense } from 'react';
import '../style/Main.css'
import axios from 'axios';
import { UserOutlined } from '@ant-design/icons';
import { Layout, theme, Typography, Col, Row, Avatar, Space, Dropdown } from 'antd';
import { $company, $email, company } from '../store/store'
import { useStore } from 'effector-react'
import { AuthContext } from '../context/AuthContext'
import LoaderComponents from '../components/LoaderComponents';
const { version } = require('../../package.json');
// import Icon from '@ant-design/icons';
// import TheMainLeftMenu from '../components/Main/TheMainLeftMenu';
// import TheMainGuestsBlock from '../components/Main/TheMainGuestsBlock';
// import TheMainBotBlock from '../components/Main/TheMainBotBlock';
// import TheMainReservedBlock from '../components/Main/TheMainReservedBlock';
// import TheMainHelpBlock from '../components/Main/TheMainHelpBlock';
// import TheMainAnaliticsBlock from '../components/Main/TheMainAnaliticsBlock';
// import TheMainLoyaltyBlock from '../components/Main/TheMainLoyaltyBlock';
// import TheMainTeamBlock from '../components/Main/TheMainTeamBlock';
// import TheMainCommunicationsBlock from '../components/Main/TheMainCommunicationsBlock';
// import TheMainCampingsBlock from '../components/Main/TheMainCampingsBlock';
// import NotificationHandler from '../components/Main/NotificationHandler';
// import { ReactComponent as ESCLogo } from "../assets/logo/esc.svg";

const TheMainLeftMenu = lazy(() => import('../components/Main/TheMainLeftMenu'));
const TheMainGuestsBlock = lazy(() => import('../components/Main/TheMainGuestsBlock'));
const TheMainBotBlock = lazy(() => import('../components/Main/TheMainBotBlock'));
const TheMainReservedBlock = lazy(() => import('../components/Main/TheMainReservedBlock'));
const TheMainHelpBlock = lazy(() => import('../components/Main/TheMainHelpBlock'));
const TheMainAnaliticsBlock = lazy(() => import('../components/Main/TheMainAnaliticsBlock'));
const TheMainLoyaltyBlock = lazy(() => import('../components/Main/TheMainLoyaltyBlock'));
const TheMainTeamBlock = lazy(() => import('../components/Main/TheMainTeamBlock'));
const TheMainCommunicationsBlock = lazy(() => import('../components/Main/TheMainCommunicationsBlock'));
const TheMainCampingsBlock = lazy(() => import('../components/Main/TheMainCampingsBlock'));

const { Title, Text } = Typography;
const { Header, Sider, Content, Footer } = Layout;

const Main = () => {
    const currentYear = new Date().getFullYear();
    const auth = useContext(AuthContext)
    const email = useStore($email)
    const companyData = useStore($company)
    const [openAvatarMenu, setOpenAvatarMenu] = useState(false);
    const [selectItemLeftMenu, setSelectItemLeftMenu] = useState({
        label: 'Гости'
    })

    const handleAvatarMenuClick = (e) => {
        if (e.key === '3') {
            setOpenAvatarMenu(false);
        }
    };
    const handleOpenAvatarMenuChange = (flag) => {
        setOpenAvatarMenu(flag);
    };
    const items = [
        {
            label: 'Выйти',
            key: '1',
            onClick: (() => { auth.logout() })
        }
    ];

    const {
        token: { colorBgContainer1 },
    } = theme.useToken();
    useEffect(() => {
        console.log(selectItemLeftMenu)
    }, [selectItemLeftMenu])

    useEffect(() => {
        axios.get('/api/user/company', { headers: { Authorization: `Bearer ${auth.token}` } })
            .then(res => {
                if (res.status === 200) {
                    company(res.data[0])
                } else {
                    // message.warning('Ошибка. Попробуйте, пожалуйста, еще раз', 2)
                }
            })
            .catch((error) => {
                if (error.response.status === 500) {
                    // message.error('Ошибка сервера. Попробуйте, пожалуйста, позже', 2)
                }
            })
            .finally(() => {
            })
    }, [auth.token])
    return (

        <Layout>
            <Sider
                breakpoint="lg"
                collapsedWidth="0"
                onBreakpoint={(broken) => {
                    console.log(broken);
                }}
                onCollapse={(collapsed, type) => {
                    // console.log(collapsed, type);
                }}
            >
                <div className="logo-vertical">
                    <Title level={2} style={{ padding: '0', margin: '10px', textAlign: 'center', cursor: 'default' }}>EGC</Title>
                </div>
                <TheMainLeftMenu setSelectItemLeftMenu={setSelectItemLeftMenu} />
                <Footer style={{ textAlign: 'center', padding: '20px', height: '78px' }}>
                    EGC© 2023-{currentYear}<br />
                    version: {version}
                </Footer>
            </Sider>
            <Layout>
                <Header style={{ padding: 0, height: '64px' }}>
                    <Row style={{ margin: '0 40px 0 20px' }}>
                        <Col span={12}>
                            <Text>{companyData} | {selectItemLeftMenu.label}</Text>
                        </Col>
                        <Col span={12} style={{ direction: 'rtl' }}>
                            <Space style={{ overflow: 'auto' }} wrap size={16}>
                                <Dropdown
                                    menu={{
                                        items,
                                        onClick: handleAvatarMenuClick,
                                    }}
                                    onOpenChange={handleOpenAvatarMenuChange}
                                    open={openAvatarMenu}
                                >
                                    <Avatar size={40} icon={<UserOutlined />} />
                                </Dropdown>
                                <Text>{email}</Text>
                            </Space>
                        </Col>
                    </Row>
                </Header>
                <Content style={{ margin: '24px 16px 0' }}>
                    <div style={{ height: '100%', maxHeight: '100%', backgroundColor: '#DEC9FF80', borderRadius: '10px', overflow: 'auto' }}>
                        {
                            selectItemLeftMenu.label === 'Гости' &&
                            <Suspense fallback={<LoaderComponents />}>
                                <TheMainGuestsBlock></TheMainGuestsBlock>
                            </Suspense>
                        }
                        {
                            selectItemLeftMenu.label === 'Настройка бота' &&
                            <Suspense fallback={<LoaderComponents />}>
                                <TheMainBotBlock></TheMainBotBlock>
                            </Suspense>
                        }
                        {selectItemLeftMenu.label === 'Бронирование' &&
                            <Suspense fallback={<LoaderComponents />}>
                                <TheMainReservedBlock></TheMainReservedBlock>
                            </Suspense>
                        }
                        {selectItemLeftMenu.label === 'Кампании' &&
                            <Suspense fallback={<LoaderComponents />}>
                                <TheMainCampingsBlock />
                            </Suspense>
                        }
                        {selectItemLeftMenu.label === 'Поддержка' &&
                            <Suspense fallback={<LoaderComponents />}>
                                <TheMainHelpBlock />
                            </Suspense>

                        }
                        {selectItemLeftMenu.label === 'Статистика' &&
                            <Suspense fallback={<LoaderComponents />}>
                                <TheMainAnaliticsBlock />
                            </Suspense>
                        }
                        {selectItemLeftMenu.label === 'Система лояльности' &&
                            <Suspense fallback={<LoaderComponents />}>
                                <TheMainLoyaltyBlock />
                            </Suspense>
                        }
                        {selectItemLeftMenu.label === 'Сотрудники' &&
                            <Suspense fallback={<LoaderComponents />}>
                                <TheMainTeamBlock />
                            </Suspense>
                        }
                        {selectItemLeftMenu.label === 'Коммуникация' &&
                            <Suspense fallback={<LoaderComponents />}>
                                <TheMainCommunicationsBlock />
                            </Suspense>
                        }
                    </div>
                </Content>

            </Layout>
        </Layout>
    )
}
export default Main;
